import axios from "axios";
import swal from "sweetalert";
import { loginConfirmedAction, logout } from "../store/actions/AuthActions";

export function signUp(
  email,
  password,
  password_confirmation,
  phone_number,
  user_date,
  address,
  business_type
) {
  //axios call
  const postData = {
    email,
    password,
    password_confirmation,
    phone_number,
    user_date,
    address,
    business_type,
    returnSecureToken: true,
  };
  return axios.post(
    `https://talentworld.netwave-tech.com/api/register`,
    postData
  );
}
export function prosignUp(
  first_name,
  last_name,
  address,
  phone_number,
  email,
  password,
  confirm_password,
  // zipcode,
  // jobtitle,
  history
) {
  //axios call
  const postData = {
    first_name,
  last_name,
  address,
  phone_number,
  email,
  password,
  confirm_password,
  // zipcode,
  // jobtitle,
    returnSecureToken: true,
  };
  return axios.post(
    `https://talentworld.netwave-tech.com/api/professionalregister`,
    postData
  );
}

export function prologin(email, password) {
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return axios.post(
    `https://talentworld.netwave-tech.com/api/professionallogin`,
    postData
  );
}
export function login(email, password) {
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return axios.post(
    `https://talentworld.netwave-tech.com/api/userLogin`,
    postData
  );
}

export function formatError(errorResponse) {
  switch (errorResponse) {
    case "EMAIL_EXISTS":
      //return 'Email already exists';
      swal("Oops", "Email already exists", "error");
      break;
    case "EMAIL_NOT_FOUND":
      //return 'Email not found';
      swal("Oops", "Email not found", "error", { button: "Try Again!" });
      break;
    case "INVALID_PASSWORD":
      //return 'Invalid Password';
      swal("Oops", "Invalid Password", "error", { button: "Try Again!" });
      break;
    case "USER_DISABLED":
      return "User Disabled";

    default:
      return "";
  }
}

export function saveTokenInLocalStorage(tokenDetails) {
  tokenDetails.expireDate = new Date(
    new Date().getTime() + tokenDetails.expiresIn * 1000
  );
  localStorage.setItem("userDetails", JSON.stringify(tokenDetails));
}
export function prosaveTokenInLocalStorage(tokenDetails) {
  tokenDetails.expireDate = new Date(
    new Date().getTime() + tokenDetails.expiresIn * 1000
  );
  localStorage.setItem("proDetails", JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, history) {
  setTimeout(() => {
    dispatch(logout(history));
  }, timer);
}

export function checkAutoLogin(dispatch, history) {
  const tokenDetailsString = localStorage.getItem("userDetails");
  let tokenDetails = "";
  if (!tokenDetailsString) {
    dispatch(logout(history));
    return;
  }

  tokenDetails = JSON.parse(tokenDetailsString);
  let expireDate = new Date(tokenDetails.expireDate);
  let todaysDate = new Date();

  if (todaysDate > expireDate) {
    dispatch(logout(history));
    return;
  }
  dispatch(loginConfirmedAction(tokenDetails));

  const timer = expireDate.getTime() - todaysDate.getTime();
  runLogoutTimer(dispatch, timer, history);
}
